import React from 'react';
import { Grid, Typography, Box } from '@material-ui/core';
import { Cached } from '@material-ui/icons';
import moment from 'moment';
import clsx from 'clsx';

const RefreshSection = ({ classes, lastSyncTime, handleRefresh }) => {
  return (
    <Box style={{ marginTop: '0', marginBottom: '0px' }}>
      <Grid
        container
        className={classes.refreshContainerSty}
        justifyContent="flex-end"
        style={{ marginTop: '0', marginBottom: '0px' }}
      >
        <Typography variant="caption" className={clsx(classes.padR20)}>
          {`Last Synced @ ${moment(lastSyncTime).format('DD-MMM-YYYY HH:mm:ss')}`}
        </Typography>
        <Typography
          variant="caption"
          color="primary"
          className={classes.refreshSty}
          onClick={handleRefresh}
        >
          Refresh
          <Cached color="primary" style={{ fontSize: 15 }} />
        </Typography>
      </Grid>
    </Box>
  );
};

export default RefreshSection;

